import { createLocalStorageStateHook } from "use-local-storage-state";

export interface IMenuPosition {
  x: number;
  y: number;
}

const useMenuPosition = createLocalStorageStateHook<IMenuPosition>(
  "menuPosition",
  {
    x: 0,
    y: 0,
  }
);

export default useMenuPosition;
